import React from "react";
import classes from "./styles/style.module.css";
import PodiumText from "./PodiumText";
import getProfileImage from "../../../assets/Hooks/getProfileImage";
import FirstMedal from "../../../assets/images/joftPooch/FirstMedal.png";
import SecondMedal from "../../../assets/images/joftPooch/secondMedal.png";
import ThirdMedal from "../../../assets/images/joftPooch/thirdMedal.png";
import FirstMContainer from "../../../assets/images/joftPooch/FirstMContainer.svg";
import SecondMContainer from "../../../assets/images/joftPooch/SecondMContainer.svg";
import ThirdMContainer from "../../../assets/images/joftPooch/thirdMContainer.svg";
import FirstPlatformVector from "../../../assets/images/joftPooch/firstPlatformVector.png";
import SecondVector from "../../../assets/images/joftPooch/secondVecotor.png";

import { useNavigate } from "react-router-dom";

const PodiumElement = ({ user, order, type }) => {
  const getMContainer = () => {
    if (order === 1) {
      return (
        <div className={classes.MedalContainer}>
          <img src={FirstMContainer} alt="FirstMContainer" />
          <p>1</p>
        </div>
      );
    } else if (order === 2) {
      return (
        <div className={classes.MedalContainer}>
          <img src={SecondMContainer} alt="SecondMContainer" />
          <p>2</p>
        </div>
      );
    } else {
      return (
        <div className={classes.MedalContainer}>
          <img src={ThirdMContainer} alt="thirdMContainer" />
          <p>3</p>
        </div>
      );
    }
  };

  const getVectotContainer = () => {
    if (order === 1) {
      return (
        <>
          <div className={classes.vectorContainer}>
            <img src={FirstPlatformVector} alt="secondPlaceVector" />
          </div>
          <div className={classes.firstPlatform}>
            <img src={FirstMedal} alt="FirstMedal" />
          </div>
        </>
      );
    } else if (order === 2) {
      return (
        <>
          <div className={classes.vectorContainer}>
            <img src={SecondVector} alt="secondPlaceVector" />
          </div>
          <div className={classes.secondPlatform}>
            <img src={SecondMedal} alt="SecondMedal" />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className={classes.vectorContainer}>
            <img
              src={SecondVector}
              alt="ThirdPlaceVector"
              className={classes.thirdVector}
            />
          </div>
          <div className={classes.thirdPlatform}>
            <img src={ThirdMedal} alt="ThirdMedal" />
          </div>
        </>
      );
    }
  };

  const navigate = useNavigate();

  return (
    <div className="col-4 mx-0 px-0">
      {user && (
        <>
          <div className={classes.thirdPlace}>
            <div
              className={classes.imageContainer}
              onClick={() =>
                navigate(`/scoreHistory/${user.userId}?order=${type}`)
              }
            >
              {getProfileImage(user.profileImage)}
              {getMContainer()}
            </div>
            <PodiumText
              id={user._id}
              scores={user.totalScore}
              name={user.fullName}
            />
          </div>
          {getVectotContainer()}
        </>
      )}
    </div>
  );
};

export default PodiumElement;
